import { gql } from "@apollo/client";

export const UPLOAD_VIDEO = gql`
  mutation ($title: String!, $video: Upload!) {
    uploadVideo(title: $title, video: $video) {
      ... on VideoType {
        id
        title
        videoUrl
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const UPLOAD_THREE_D_MODEL = gql`
  mutation ($title: String!, $model: Upload!) {
    upload3dModel(title: $title, model: $model) {
      ... on ModelType {
        id
        title
        modelUrl
      }
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;
